import { render, staticRenderFns } from "./Layout-footer.vue?vue&type=template&id=448bcc65&scoped=true"
import script from "./Layout-footer.vue?vue&type=script&lang=js"
export * from "./Layout-footer.vue?vue&type=script&lang=js"
import style0 from "./Layout-footer.vue?vue&type=style&index=0&id=448bcc65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448bcc65",
  null
  
)

export default component.exports